import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

export function SortableHeader({ label, field, currentSort, currentOrder, onSort, className = "" }) {
  const isActive = currentSort === field;
  const handleClick = () => {
    if (isActive) {
      onSort(field, currentOrder === "asc" ? "desc" : "asc");
    } else {
      onSort(field, "asc");
    }
  };

  return (
    <th
      className={`px-6 py-3 text-xs font-bold text-[#0F172A] tracking-wider uppercase cursor-pointer select-none hover:bg-[#F1F5F9] transition-colors ${className}`}
      onClick={handleClick}
      data-testid={`sort-header-${field}`}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {isActive ? (
          currentOrder === "asc" ? <ArrowUp size={12} /> : <ArrowDown size={12} />
        ) : (
          <ArrowUpDown size={12} className="text-[#CBD5E1]" />
        )}
      </span>
    </th>
  );
}
